import { isHumanCallInProgress } from '@/utils/caseStateHelpers';

import type { CaseItem } from './types';

/**
 * Whether the Workforce Console offers to reassign the case (LA-8061). A case whose human call
 * is live (a human-call state with an `active_call_id`, the "Human Call In Progress" column) is
 * not: moving it would pull the case out from under the rep on the phone, and the server rejects
 * it. A human call that has not been dialled yet ("Human Call Needed") can still be reassigned.
 */
export function canReassignCase(c: CaseItem): boolean {
  return !isHumanCallInProgress(c.status, c.activeCallId);
}
